import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AplicationsComponent } from './aplications.component';
import { FormsModule } from '@angular/forms';
import { aDisabledModule } from 'directives/aDisabled';
import { ApplicationsHttp } from 'providers/http/ApplicationsHttp';
import { ExcelService } from 'util/ExcelService';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    aDisabledModule
  ],
  declarations: [AplicationsComponent],
  exports: [AplicationsComponent],
  providers: [ApplicationsHttp, ExcelService]
})
export class AplicationsModule { }
